/**
 * 新老兼容代码
 */
import Vue from 'vue'
import { env } from 'bootsets/runtime'
import reLogin from 'bootsets/components/re-login'
import msg from 'bootsets/components/msg'
import { ErrorCode } from 'core/constant'

Vue.use(require('vue-resource'))

if (env.NODE_ENV === 'development') {
    Vue.config.debug = true
}

Vue.config.devtools = true

// 拦截 http 请求
Vue.http.interceptors.push({
    request(request) {
        return request
    },
    response(response) {
        if (response.ok) {
            const { errorCode } = response.data
            switch (errorCode) {
            case ErrorCode.SUCCESS:
                break
            case ErrorCode.EUSER:
                reLogin.open() // session超时
                break
            default:
                break
            }
        } else {
            msg.danger('操作失败了, 请重试 !')
        }
        return response
    }
})


// WEBPACK FOOTER //
// ./bootsets/compatibility/base.js